<script>
  import { onMount } from 'svelte';
  import * as animateScroll from 'svelte-scrollto';
import { element } from 'svelte/internal';
  export let title = "Curbza Terms of Service";
  export let updatedAt = new Date("2017-10-05");
  export let basepath = '/';

  onMount(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  });

  const onLinkClick = (linkName) => {

  };
</script>

<style>
  .article-container {
    position: relative;
    padding: var(--page-padding);
  }

  .article-container aside {
    position: fixed;
    top: calc(var(--navbar-height) + 1vw);
    left: 2vw;
    background-color: var(--light);
    border-radius: 8px;
  }

  .article-container article {
    padding: 32px;
    padding-left: calc(var(--sidebar-width) + 32px);

  }
</style>

<main class="article-container">
  <aside>
    <nav class="col-sm-3 hidden-xs margin-top-16" id="myScrollspy">
      <ul class="nav nav-pills nav-stacked" data-spy="affix" data-offset-top="0">
        <li
          class="active">
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-1'})}>Introduction</a>
        </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-2'})}>What is Curbza?</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-3'})}>Network Management</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-4'})}>Rules for Buying and Selling</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-5'})}>Prohibited Items</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-6'})}>Safety</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-7'})}>Your Account</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-8'})}>Sharing Your Content and Info.</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-9'})}>Privacy</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-10'})}>Fees &amp; Payments</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-11'})}>Disclaimer</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-12'})}>Termination</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-13'})}>Governing Law &amp; Disputes</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-14'})}>Definitions</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-15'})}>Copyright Notice</a>
          </li>
        <li>
          <a
            href='/#'
            on:click={() => animateScroll.scrollTo({ element: 'section-16'})}>Miscellaneous</a>
          </li>
      </ul>
    </nav>
  </aside>

  <article>
    <div class="col-xs-12 col-sm-9">
      <h1 class="title">{title}</h1>
      <p class="heading">{updatedAt}</p>
      <h2 id="section-1">1. Introduction</h2>
      <p>
      Welcome to Curbza! We're delighted to have you join us. This is your
      community as much as it is ours, so in order to keep it a safe and happy
      place for all, please read this agreement carefully and follow the Curbza
      rules.
      </p>
      <p>
      Curbza  ("<strong><u>Curbza</u></strong>"/"<strong><u>we</u></strong>"/"
      <strong><u>us</u></strong>"/"<strong><u>our</u></strong>") owns and operates
      the Curbza website located at&nbsp;<a href="{basepath}">curbza.com</a>&nbsp;
      ("<strong><u>Site</u></strong>") and the Curbza mobile application
      ("<strong><u>App</u></strong>") available for download on Google Play and the
      App Store, which collectively constitute the "<strong><u>Curbza Platform</u></strong>."
      The Curbza Platform is for registered users ("<strong><u>Members</u></strong>")
      to buy and sell goods. Our terms of service are designed to create a fair,
      friendly and safe environment for all Curbza Members. Being informed on what
      is permitted on the Curbza Platform can help you avoid unintentionally
      breaking the rules and helps create a community full of trustworthy Members.
      </p>
      <p>
      By accessing or using the Curbza Platform, you agree to all terms described
      herein and all terms and policies incorporated by reference
      ("<strong><u>Terms</u></strong>"), which may be updated from time to time at
      our discretion. Curbza has created the Terms so that all Members follow the
      same basic rules of conduct. These Terms are here to benefit and protect
      everyone who is a part of this community.
      </p>
      <h2 id="section-2">2. What is Curbza?</h2>
        <ul>
          <li>
            <p>
              Curbza is a mobile application made for Android and iOS devices that
              streamlines the process of online buying, selling and exchange.
              Our App allows Members to browse items for sale in a variety of ways:
              by category, Network, or by user stores.
            </p>
          </li>
          <li>
            <p>
              In order to access certain parts of the Curbza Platform, you may be
              required to create a Curbza account (an "<strong><u>Account</u></strong>").
              A personal store will be automatically created for each Member when they
              log in to the App for the first time. Through their store, Members can
              inventory things they own and create a database of things they would
              like to sell.
            </p>
          </li>
          <li>
            <p>
              Networks are managed and moderated directly by Network Managers and/or
              by other members of the Curbza team (see: <a href="section-3">Section 3</a> below).
            </p>
          </li>
          <li>
            <p>
              Each Network may have specific rules that are not created by Curbza and
              are not reviewed or controlled by Curbza. However, if there are any
              discrepancies between specific rules in a Network and these Terms, these
              Terms will govern in all matters. If you are concerned about any specific
              rules in a Network, you may contact Curbza to seek clarifications. Our
              contact information is available at the end of these Terms.
            </p>
          </li>
        </ul>
      <h2 id="section-3">3. Network Management</h2>
      <p>
        A "<strong><u>Network Manager</u></strong>" is someone who creates a Network on the
        Curbza Platform and/or is given the role of administrator for a Network.
        We'll choose our Network Managers based on their experience and their
        ability to motivate and promptly answer other members of their Network.
        Because Curbza staff can't be everywhere at once, it's important that
        we have parties whom we can trust to act on our behalf and foster a safe
        and happy environment for the entire Curbza community.
      </p>
      <p>
      The role of the Network Managers is to encourage a strong, peaceful, and
      happy network. Occasionally being in this role might mean that you need to
      help mediate conflicts between Members in a neutral, impartial manner. The
      ultimate goal of the Network Manager is to encourage Members to participate
      in their Network in a respectful and peaceful manner. We expect our Network
      Managers to uphold the Curbza standard of good member relations and treat all
      members of their Network with absolute respect. If a Network Manager finds
      himself or herself in conflict with another Member where they can no longer
      act as a neutral party, we encourage them to bring the issue to the Curbza
      team for mediation. For clarification, Network Manager is a voluntary role,
      and they have no legal obligation and will assume no liability for attempting
      to resolve conflicts among our Members.
      </p>
      <p>
      It is important that Network Managers accept new requests to join their
      Network in a timely manner and offer a simple introduction to ease Members
      into the Network. Managers of local communities, may, with the assistance of
      the Curbza team, opt to allow only people within a reasonable geographical
      distance of their Network to join, while reasonably allowing access to those
      who frequently visit that Network to take part.
      </p>
      <p>
      Network Managers responding to a serious cause can restrict access to people
      who break the Curbza Terms. Network Managers do not have the right to restrict
      a Member's access for any other reasons than inappropriate behavior or breach
      of the Curbza Terms or breach of a Network's rules; personal relationships
      with a Member, or a Member's behavior in person or on another platform are
      not grounds to restrict a Member's access to any Curbza Network.
      </p>
      <p>
      It may make sense for a Network to have its own rules. Network Managers have
      the right to implement rules that make sense to them as long as they are
      reasonable and do not prevent anyone from the having the best possible
      Curbza experience. The Network Manager does not have the right to restrict
      Members from using Curbza functions, they cannot ask members to use Curbza
      in ways which were not intended, and under no circumstances can a Network
      Manager charge members any sort of fee for their services or to use Curbza.
      </p>
      <p>
      Network Managers may remove any content they deem inappropriate, illegal or
      against the Terms or a Network's rules. Curbza will rely on its Network
      Manager to be diligent and discerning. As a security measure, all items
      posted to Curbza are considered grey listed until the team at Curbza 
      approves them. Network Managers, may not remove Items based on how long they
      have been listed, the status of a Member or because of past behaviour of
      that Member in the community. Only Curbza can decide who to black list from
      using the Curbza Platform.
      </p>
      <p>
      Curbza reserves the right to remove any Network Manager from the Curbza
      Platform for breach of the Terms or for making, publishing, ratifying or
      endorsing of any disparaging remarks including but not limited to defamatory
      or malicious content against or about Curbza, its employees and/or
      its Members.
      </p>
      <h2 id="section-4">4. Rules for Buying and Selling</h2>
      <p>
      Curbza is not involved in, and not a party to, any transactions between
      Members. For further clarity:
      </p>
      <ol>
        <li>
          <p>
            All agreements made for the exchange or purchase of goods or services
            are made directly between Members. The Curbza Platform is only a
            marketplace in which the communication between Sellers and Buyers
            takes place
          </p>
        </li>
        <li>
          <p>
            Curbza does not pre-screen or vet the products or services offered by
            Sellers. We do, however, add every item to a grey list, and reserve the
            right to remove any item from the Curbza Platform that we believe does
            not reflect the Curbza's values. Members should always do their own due
            diligence, and review Curbza Best Practices.
          </p>
        </li>
        <li>
          <p>
            Members must be over the age of 16 or have parental or legal guardian
            supervision to list, buy, sell or exchange any Item through the Curbza
            Platform.
          </p>
        </li>
        <li>
          <p>
            Members must have the legal right to sell any item(s) they have posted
            for sale on the Curbza Platform. Members represent and warrant that
            they are the sole owners of items they offer for sale on the Curbza
            Platform.
          </p>
        </li>
        <li>
          <p>
            Members are solely responsible for calculating, remitting and repaying
            all applicable taxes in respect of goods or services they buy or sell
            through the Curbza Platform. Curbza is not responsible for withholding,
            collecting, reporting, or remitting any sales, use, value added, or
            similar tax arising from any transaction you complete through the
            Curbza Platform.
          </p>
        </li>
        <li>
          <p>
            Disputes between Members must be resolved between them. Members may
            decide to inform Network Managers of disputes. Network Managers and/or
            Curbza may at their own discretion endeavour to assist where possible
            in the resolution of Member disputes. Curbza may be requested via email
            at <a href="mailto:support@curbza.com?Subject=Terms Of Service" target="_top">support@curbza.com</a>
            to assist in resolution of disputes. Curbza may, at its own discretion,
            attempt to help resolve disputes as an informal mediator based on its
            experience working with the membership, however responsibility for
            resolution of disputes remains solely with Members.
          </p>
        </li>
        <li>
          <p>
            Curbza has a no tolerance policy for breach of the Terms. Curbza
            reserves the right to remove any item posted for sale and/or, in
            Curbza's sole determination, any Member from the Curbza Platform.
          </p>
        </li>
        <li>
          <p>
            The Curbza Platform is used for the posting of items for sale by
            Members and we do not advertise or sell our own products or services
            through the Platform. As a result, we have no control over and, to the
            extent permitted by law, make no representations, warranties or
            conditions in relation to the merchantability, suitability, quality,
            safety, fitness, condition, ownership or legality of any items
            advertised for sale on Curbza although we do aim to ensure a safe
            marketplace through these Terms, our policies and the requirements of
            our Prohibited Items list which all Members must adhere to.
            <strong><u>ALL PURCHASES ARE FINAL, AND THERE ARE NO REFUNDS, UNLESS
              YOU AND THE SELLER OTHERWISE AGREE AND MAKE ARRANGEMENTS FOR A REFUND.
              Curbza will not be responsible for facilitating refunds.</u></strong>
          </p>
        </li>
      </ol>
      <h2 id="section-5">5. Prohibited Items</h2>
      <p>
      Curbza prohibits the sale of a number of items, such as firearms, regulated
      products and services and illegal goods and services. It is up to Members to
      be sure they are not posting any good or service that is illegal in their
      jurisdictions. Curbza will maintain a list accessible through&nbsp;
      <a href="{basepath}">curbza.com</a>&nbsp;of all items that are
      prohibited from the Curbza Platform ("<strong><u>Prohibited Items</u></strong>");
      this list is not exhaustive and will be updated from time to time in Curbza's
      sole discretion, and is part of the Curbza Terms. It is up to the Member to
      review the list often for any updates. Curbza may, at its sole discretion and
      without notice, remove any item, content or information that it views as
      being a Prohibited Item. Network Managers also have authority within their
      community/communities to remove Prohibited Items without notice. Members may
      report any Prohibited Items or content they see directly from the items page
      with the report button.
      </p>
      <h2 id="section-6">6. Safety</h2>
      <p>
      We're vigilant in our desire to keep Curbza a safe environment for all, we
      also can't be everywhere at once, so we rely on our Members to help. This
      includes the following commitments from each Member (which you specifically
      acknowledge and agree to comply with)
      </p>
      <ol>
        <li>
          <p>
          No bullying, threatening, intimidation, or harassment of any Member;
          </p>
        </li>
        <li>
          <p>
          No content that: is hate speech, threatening, is sexual or pornographic; incites violence; or contains nudity or graphic or gratuitous violence;
          </p>
        </li>
        <li>
          <p>
          No violation of any law, contract, intellectual property or other third-party right or commission of a tort;
          </p>
        </li>
        <li>
          <p>
          No uploading, transmitting, distributing, storing, creating, or otherwise selling or offering for sale anything that violates the list of Prohibited Items;
          </p>
        </li>
        <li>
          <p>
          No use of the Curbza Platform to do anything unlawful, fraudulent, misleading, malicious or discriminatory;
          </p>
        </li>
        <li>
          <p>
          No posting or distribution of any spam, chain letters, or pyramid schemes;
          </p>
        </li>
        <li>
          <p>
          No collection, copying, modification or distribution of any Members' content or information for any purpose other than responding to and facilitating a purchase or sale through the Curbza Platform;
          </p>
        </li>
        <li>
          <p>
          No use of any robot, spider, scraper or any other automated means to access the Curbza Platform using automated means without our prior permission;
          </p>
        </li>
        <li>
          <p>
          No promotions of or links to other platforms competing directly or indirectly with Curbza;
          </p>
        </li>
        <li>
          <p>
          No promotions of or links to external websites or mobile applications that contain content that goes against the intention of these Terms or Curbza policies (for example: gambling and pornographic websites or web or mobile properties distributing dangerous, illegal or copyrighted content);
          </p>
        </li>
        <li>
          <p>
          No posting of personally identifiable information publicly, such as but not limited to phone numbers, street addresses or banking information. For your safety, you may choose to share this information with specific Members in private messages;
          </p>
        </li>
        <li>
          <p>
          No uploading of viruses or other malicious code;
          </p>
        </li>
        <li>
          <p>
          No bypassing of measures used to prevent or restrict access to Curbza;
          </p>
        </li>
        <li>
          <p>
          No solicitation of login information or accessing an account belonging to someone else; and
          </p>
        </li>
        <li>
          <p>
          No facilitation, encouragement or actual violations of our Terms or policies.
          </p>
        </li>
      </ol>
      <p>
        By using the Curbza Platform, you acknowledge that you might be exposed to materials that you consider offensive, indecent or objectionable. Under no circumstances will Curbza be liable for such materials or content, but if you see any offensive or otherwise objectionable content on the Curbza Platform please inform us by email, or report the content in question through the App. Curbza reserves the right, but is under no obligation to regulate content on the Curbza Platform. As stated previously, Curbza also has the sole discretion to limit, modify, suspend or discontinue or remove any content. However, Curbza and its representatives shall not be liable for any losses, damages or harm resulting from such action or inaction.
      </p>
      <h2 id="section-7">7. Your Account</h2>
      <p>
      We want our Curbza community to be the most reliable and trustworthy place for every Member, so when we you create an Account on Curbza we ask that to provide your real name. In connection with creating an Account, you must provide certain information ("<strong><u>Registration Data</u></strong>") and answer all questions or fields marked "required". Members will hold the sole responsibility and liability for any and all loss, damage, or additional costs that we or any other Member may incur as a result of any submission of false, incorrect or incomplete information or failure to update your registration information as needed
      </p>
      <p>
      You acknowledge and agree, in relation to creating and maintaining an Account, that:
      </p>
      <ul>
        <li>
          <p>
            you will provide true, accurate, current and complete Registration Data and that you will maintain and update such Registration Data to keep it true, accurate, current and complete.
          </p>
        </li>
        <li>
          <p>
          if we suspend or terminate your Account, you will not create another one without our permission.
          </p>
        </li>
        <li>
          <p>
          if you are under 16, you are only permitted to access and use the Curbza Platform with a parent or legal guardian's supervision (including that parent or guardian agreeing to these Terms on your behalf). Curbza reserves the right to confirm such consent at any time and to discontinue your use of our services and the Curbza Platform should such consent not be granted.
          </p>
        </li>
        <li>
          <p>
          convicted sex offenders are not permitted to obtain an Account or otherwise access and use the Curbza Platform.
          </p>
        </li>
        <li>
          <p>
          you will not share passwords, let anyone else access your account, or do anything else that might jeopardize the security of your Account.
          </p>
        </li>
        <li>
          <p>
          if you have knowledge that your password was compromised, you should inform us immediately in order to recover your Account.
          </p>
        </li>
        <li>
          <p>
          you will not create more than one Account or create an Account on behalf of anyone other than yourself without permission.
          </p>
        </li>
      </ul>
      <h2 id="section-8">8. Sharing Your Content and Information</h2>
      <p>
      In the course of using the Curbza Platform, you may transmit or otherwise
      make available certain content, including information about yourself, content,
      messages, materials, data, information, text, photos, graphics, code or other
      items or materials ("<strong><u>User Content</u></strong>") through interactive
        areas or services, such as posting items for sale, making an offer, private
        messaging, or other areas or services. User Content may be publicly
        viewable in some instances. Curbza reserves the right, but does not have
        the obligation, to remove, screen or edit any User Content posted or
        stored on the Curbza Platform at any time and for any reason without
        notice. Members own the content and information they post on Curbza. In addition:
      </p>
      <ol>
        <li>
          <p>
          For content that is covered by intellectual property rights, like photos and videos, Members grant Curbza a non-exclusive, transferable, sub-licensable, royalty-free, worldwide license right to use, modify, publish, transmit, make available and otherwise exploit content that is posted by Members on the Curbza Platform and in any other media for administrative and promotional purposes. By posting content on the Curbza Platform, Members represent and warrant that they have the necessary rights to grant the license rights granted to Curbza herein.
          </p>
        </li>
        <li>
          <p>
          Members may delete any content or information that belongs to them, but acknowledge that any information and content shared with other Members may remain available to those Members and the persons with whom they have shared that content and information.
          </p>
        </li>
        <li>
          <p>
          By posting content or information, Members are permitting other Members, to access, share and use that information, and to associate it with them (i.e. a member's name and profile picture may appear next to information they post or that is share publicly on Curbza).
          </p>
        </li>
      </ol>
      <h2 id="section-9">9. Privacy</h2>
      <p>
      To fully benefit from the Curbza Platform, you need to be a registered user and provide certain personal information to us in connection with setting up your Account. For information about how we collect, use and store personal information, please refer to our <a href="{basepath}curbza_privacy_policy/">Privacy Policy</a>, which you are deemed to have accepted through your use of the Curbza Platform.
      </p>
      <h2 id="section-10">10. Fees &amp; Payments</h2>
      <p>
      Curbza is free to use, including creating an Account, joining and participating in Networks as well as downloading and using our Apps.
      </p>
      <p>
      Transactions between Members will vary in value and are negotiated directly between Members. If you are a Seller you are committing to selling items at the cost agreed with a particular Buyer.
      </p>
      <h2 id="section-11">11. Disclaimer of Warranties, Limitation of Liability, Release and Indemnity</h2>
      <p>
      <strong><u>DISCLAIMER.</u></strong>&nbsp;THE INFORMATION AND MATERIALS PROVIDED ON THE CURBZA PLATFORM ARE PROVIDED "AS IS." WE DO NOT REPRESENT, WARRANT OR OFFER ANY CONDITIONS THAT: (I) THE INFORMATION OR MATERIALS ON THE CURBZA PLATFORM ARE CORRECT, ACCURATE, RELIABLE OR COMPLETE; (II) THE FUNCTIONS CONTAINED ON THE CURBZA PLATFORM WILL BE UNINTERRUPTED OR ERROR-FREE; OR (III) THE CURBZA PLATFORM OR THE SERVER(S) THAT MAKE IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. WE SPECIFICALLY DISCLAIM ALL REPRESENTATIONS, WARRANTIES AND CONDITIONS, EITHER EXPRESS, IMPLIED, STATUTORY, BY USAGE OF TRADE, COURSE OF DEALING OR OTHERWISE INCLUDING BUT NOT LIMITED TO ANY IMPLIED WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT, TITLE, SATISFACTORY QUALITY OR FITNESS FOR A PARTICULAR PURPOSE. WE DO NOT WARRANT, ENDORSE, GUARANTEE OR ASSUME ANY RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY ANY MEMBER OR THIRD PARTY THROUGH THE CURBZA PLATFORM OR IN RESPECT TO ANY WEBSITE THAT CAN BE REACHED FROM A LINK ON THE CURBZA PLATFORM OR FEATURED IN ANY BANNER OR OTHER ADVERTISING ON THE CURBZA PLATFORM, AND WE SHALL NOT BE A PARTY TO ANY TRANSACTION THAT YOU MAY ENTER INTO WITH ANY SELLER
      </p>
      <p>
      <strong><u>LIMITATION OF LIABILITY.</u></strong>&nbsp;UNDER NO CIRCUMSTANCES SHALL WE BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY OR OTHER DAMAGES WHATSOEVER, INCLUDING, WITHOUT LIMITATION, ANY DAMAGES THAT RESULT FROM (I) YOUR USE OF OR YOUR INABILITY TO USE, THE CURBZA PLATFORM OR ANY OF THE INFORMATION OR MATERIALS CONTAINED ON THIS WEBSITE, (II) THE COST OF PROCUREMENT OF SUBSTITUTE GOODS, DATA, INFORMATION OR SERVICES, (III) ERRORS, MISTAKES, OR INACCURACIES IN THE MATERIALS ON THE CURBZA PLATFORM, OR (IV) OR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY ANY MEMBER OR THIRD PARTY THROUGH THE CURBZA PLATFORM OR IN RESPECT TO ANY WEBSITE THAT CAN BE REACHED FROM A LINK ON THE CURBZA PLATFORM OR FEATURED IN ANY BANNER OR OTHER ADVERTISING ON THE CURBZA PLATFORM, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE FOREGOING LIMITATIONS SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY LAW.
      </p>
      <p>
      <strong><u>Release.</u></strong>&nbsp;Because we do not control Members, you agree that you bear all risk and you hereby unconditionally release us (and our officers, directors, shareholders, agents, employees, affiliates, subsidiaries, and third party partners) and our designees from all claims, demands, and damages (actual and consequential) of every kind and nature, now and in the future, arising out of or in any way connected with your use of the Curbza Platform.
      </p>
      <p>
      <strong><u>Indemnity.</u></strong>&nbsp;Although we provide rules for Member conduct, we do not control or direct Members' actions on Curbza and are not responsible for the content or information Members transmit or share on Curbza. We are not responsible for any offensive, inappropriate, obscene, unlawful or otherwise objectionable content or information that may be encounter on Curbza. We are not responsible for the conduct, whether online or offline, or any Member of Curbza. You agree to hold harmless, defend and indemnify Curbza and our officers, directors, shareholders, agents, employees, affiliates, subsidiaries, and third party partners (collectively, the "<strong><u>Indemnified Parties</u></strong>&nbsp;") from all liabilities, losses, damages, deficiencies, claims, causes of action, demands and expenses, (including, but not limited to, reasonable legal fees), that are due to, arise from or otherwise relate to your conduct or your use or misuse of the Curbza Platform or Materials, including, without limitation, any actual or threatened suit, demand or claim made against the Indemnified Parties that arises out of or relates to: (i) any intellectual property rights or other proprietary rights of any third party, (ii) your breach of these Terms including without limitation your breach of any of your representations and warranties; (iii) your use of any of the Curbza Platform or Materials; or (iv) any content that you store on or transmit through the Curbza Platform. Curbza may assume exclusive control of any defense of any matter subject to indemnification by you, and you agree to cooperate with Curbza in such event.
      </p>
      <h2 id="section-12">12. Termination</h2>
      <p>
      Members may terminate their account and/or stop using the Curbza Platform at any time. Curbza reserves the right under any circumstances and without prior notice, to immediately ban or terminate or suspend all or a portion of a Member's Account and/or access to the Curbza Platform. Cause for such termination shall include, but is not limited to: Violations of the letter or spirit of these Terms or any other Curbza policies that are referenced herein and/or posted on the Curbza Platform; A request by a Member to cancel or terminate an Account they opened; Discontinuance or material modification to the Curbza Platform or any part thereof; A request and/or order from law enforcement, a judicial body, or other government agency; where provision of the Curbza Platform, or any component thereof, to a Member is or may become unlawful; unexpected technical or security issues or problems; or participation in fraudulent or illegal activities. Any such termination or suspension shall be made by Curbza in its sole discretion, and Curbza will not be responsible to any Member or any third party for any damages that may result or arise out of such termination or suspension of an account and/or access to Curbza.
      </p>
      <h2 id="section-13">13. Governing Law &amp; Disputes</h2>
      <p>
      These Terms are governed by the laws of Nova Scotia, without regard to conflict of laws principles. Where permitted by law, you agree that any action to enforce these Terms may be brought in the courts located in the Province of Nova Scotia. You further agree to submit to the personal jurisdiction of these courts for the purpose of any proceeding arising out of these Terms and waive any objections and defenses inconsistent with such venue. By using Curbza Platform, you represent and warrant that your use complies with applicable law in your jurisdiction of residence.
      </p>
      <p>
      You agree that any cause of action that you may have arising out of or related to your use of the Curbza Platform must commence within one (1) year after the cause of action arises, otherwise such cause of action shall be permanently barred.
      </p>
      <p>
      YOU UNDERSTAND AND AGREE THAT, BY ENTERING INTO THESE TERMS OF USE, AND TO THE EXTENT PERMITTED BY APPLICABLE LAWS YOU ARE WAIVING THE RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE IN A CLASS ACTION WITH RESPECT TO ANY CLAIMS ARISING IN RELATION TO THE CURBZA PLATFORM, OR SERVICES OFFERED THROUGH THE CURBZA PLATFORM.
      </p>
      <h2 id="section-14">14. Definitions</h2>
      <p>
      A "<strong><u>Buyer</u></strong>" is any Member who connects with one or more Sellers with the intent of purchasing Items.
      </p>
      <p>
      An "<strong><u>Item</u></strong>" is any good(s) and/or service posted for sale by a Seller via the Curbza Platform.
      </p>
      <p>
      A "<strong><u>Network Manager</u></strong>" is any Member of Curbza who is responsible for the management and moderation of one or more Networks.
      </p>
      <p>
      A "<strong><u>Seller</u></strong>" is any Member that posts or makes Item(s) available for sale or for free through the Curbza Platform.
      </p>
      <h2 id="section-15">15. Copyright Notice</h2>
      <p>
      Curbza does not permit any copyright infringing activities or infringement of intellectual property rights and will remove any photos or other content if properly notified that such content infringes on another's intellectual property rights. If you are a copyright owner or an agent thereof and believe that any content infringes upon your copyright, you may submit a notification to <a href="mailto:support@curbza.com?Subject=Terms Of Service" target="_top">support@curbza.com</a> and provide our representative with the following information in writing:
      </p>
      <ul>
        <li>
          <p>
            an electronic or physical signature of the person authorized to act on behalf of the owner of the copyright's interest;
          </p>
        </li>
        <li>
          <p>
            a description of the copyrighted work that you claim has been infringed, including the URL (i.e., web page address) of the location where the copyrighted work exists or a copy of the copyrighted work;
          </p>
        </li>
        <li>
          <p>
            your address, telephone number, and email address
          </p>
        </li>
        <li>
          <p>
            a statement by you that you believe in good faith that the disputed use is not authorized by the copyright owner, its agent, or the law;
          </p>
        </li>
        <li>
          <p>
            a statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright owner or authorized to act on the copyright owner's behalf.
          </p>
        </li>
      </ul>
      <p>
      You can contact our representative via email at <a href="mailto:support@curbza.com?Subject=Terms Of Service" target="_top">support@curbza.com</a>
      </p>
      <h2 id="section-16">16. Miscellaneous</h2>
      <p>
      Nothing in these Terms shall prevent us from complying with all applicable laws. We reserve all rights not expressly granted or disclaimed herein. Amendments to these Terms may be made from time to time without prior notice. Full and up-to-date Terms are available at <a href="{basepath}">curbza.com</a> for reference. <strong><u>Your use of the Curbza Platform after any amendments or updates to these Terms shall signify your acceptance of such revised terms.</u></strong> You should visit the Site periodically to review these Terms. Members must comply with all applicable laws when using or accessing Curbza. You shall not attempt to override or circumvent any of the usage rules or restrictions on the Curbza Platform. In the event that any provision or part thereof is determined by a court of competent jurisdiction to be unenforceable, such provision, or part thereof, shall be deemed to be severed from this Agreement and the remaining provisions of this Agreement shall continue in full force and effect and shall be binding upon the parties hereto as though such severed provision had not formed part of this Agreement.
      </p>
      <h2 id="section-17">17. Discontinuance of the Curbza Platform</h2>
      <p>
      Curbza may, in its sole discretion and without liability to you, modify, discontinue, terminate, suspend or shut-down (temporarily or permanently) all or any portion of the Curbza Platform at any time, without prior notice. Upon any such action by Curbza, you must immediately stop using the Curbza Platform.
      </p>
      <h2 id="section-18">18. Intellectual Property Rights</h2>
      <p>
      Unless otherwise indicated, the Curbza Platform and all content, materials, information, functionality and other materials displayed, performed, contained or available on or through the Curbza Platform, including, without limitation, the Curbza logo, and all designs, text, graphics, pictures, information, data, sound files, images, illustrations, software, other files, and the selection and arrangement thereof (collectively, the "<strong><u>Materials</u></strong>") are the property of Curbza or its affiliates or licensors, and are protected by Canadian and international copyright laws and other intellectual property rights laws.
      </p>
      <p>
      Except as otherwise provided, subject to your compliance with all of the terms and conditions of these Terms, and in consideration of your promises reflected herein (and with respect to any services requiring payment of fees, your payment of such fees), we grant   to   you   a   revocable,   personal,   non-exclusive,   non-assignable   and   non-transferable license for personal, non-commercial purposes, except where explicitly provided otherwise, to (i) access and use the Curbza Platform, (ii) cause the Materials to be displayed from a computer and/or mobile device and (iii) use the Materials, solely as permitted under these Terms (the "<strong><u>License</u></strong>"). You agree that these Terms do not grant you any rights in or licenses to the Curbza Platform or the Materials, except for this express, limited License. You will not otherwise copy, transmit, distribute, sell, resell, license, de-compile, reverse engineer, disassemble, modify, publish, participate in the transfer or sale of, create derivative works from, perform, display, incorporate into another website, or in any other way exploit any of the Materials or any other part of the  Curbza  Platform  or  any derivative  works thereof, in  whole  or  in  part  for commercial or non-commercial purposes. Without limiting the foregoing, you agree not to frame or display the Curbza Platform or Materials (or any portion thereof) as part of any other website or any other work of authorship without our prior written permission. The License granted under this section will automatically terminate if we suspend or terminate your access to the Curbza Platform
      </p>
      <h2 id="section-19">19. More Resources</h2>
      <p>
      Please forward any questions or concerns about these Terms to <a href="mailto:support@curbza.com?Subject=Terms Of Service" target="_top">support@curbza.com</a>
      </p>
      <p>
      For questions about how to use the Curbza Platform, please visit <a href="{basepath}/support/faq">curbza.com/support/faq</a>
      </p>
      <p>
      Curbza is located at 73 Tacoma Dr. Suite 400B, Dartmouth, Nova Scotia. B2W 3Y6.
      </p>
      <p>
      We thank you in advance for complying with these Terms.
      </p>
      <br/>
      <p>
        Remember: have fun, be polite, and don't put it on the curb!
      </p>
      <br/>
      <p>
      &mdash;&nbsp;Team Curbza
      </p>
    </div>
  </article>
</main>
